import "@babel/polyfill";
import Vue from "vue";
import "./plugins/vuetify";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import InstantSearch from "vue-instantsearch";
import numeral from "numeral";
import i18n from "./i18n";
import VueCookie from "vue-cookie";

numeral.register("locale", "es", {
  delimiters: {
    thousands: " ",
    decimal: ",",
  },
  abbreviations: {
    thousand: "k",
    million: "m",
    billion: "b",
    trillion: "t",
  },
  ordinal: function(number) {
    return number === 1 ? "er" : "ero";
  },
  currency: {
    symbol: "€",
  },
});

numeral.locale("es");

Vue.filter("formatNumber", function(value) {
  // load a locale
  return numeral(value / 100).format("0[.]00 $");
});

Vue.use(InstantSearch);
Vue.use(VueCookie);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount("#app");
